import { IframeWrapper } from 'features/iframe-wrapper/IframeWrapper';
import { useIframeMessageListener } from 'features/iframe-wrapper/useIframeMessageListener';
import { useEnableSidebarOnMount } from 'features/pageSidebar/useSidebarStore';
import styled from 'styled-components';

export function WorkspaceSettingsUsersPage() {
  useIframeMessageListener();
  useEnableSidebarOnMount({ openSettingsView: true });

  return (
    <StyledContainer>
      <IframeWrapper basePath="/settings/workspace/users" />
    </StyledContainer>
  );
}

const StyledContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: hidden;
`;
